var exports = {
  "i": "xaee3c4fa--f11af4--wrapper",
  "n": "xaee3c4fa--f11af4--controls",
};

module.exports = exports;
